import Vue from 'vue';
import {Prop} from 'vue-property-decorator';
import {InfoButtonText} from '../../../Models';
import Component from 'vue-class-component';

@Component
export default class InfoButton extends Vue {
  @Prop({required: true}) infoButtonText: InfoButtonText | undefined;
}
